/// <reference path="../../_ext/Bases/GridBase.ts" />

namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class VendorGrid extends _Ext.GridBase<VendorRow, any> {
        protected getColumnsKey() { return 'OMS.Vendor'; }
        protected getDialogType() { return VendorDialog; }
        protected getIdProperty() { return VendorRow.idProperty; }
        protected getInsertPermission() { return VendorRow.insertPermission; }
        protected getLocalTextPrefix() { return VendorRow.localTextPrefix; }
        protected getService() { return VendorService.baseUrl; }

        public rowSelection = new Serenity.GridRowSelectionMixin(this);

        constructor(container: JQuery, options) {
            super(container, options);
            this.slickGrid.setOptions({ rowHeight: 30 });

            //this.view.onDataLoaded.subscribe(e => {
            //    this.slickGrid.setSelectedRows([0]);
            //});
        }

        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            //grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}